import { render, staticRenderFns } from "./AiAuditLogs.vue?vue&type=template&id=3d01700b"
import script from "./AiAuditLogs.vue?vue&type=script&lang=js"
export * from "./AiAuditLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports